<template>
  <el-card class="vest-bag">
    <el-row>
      <h1 class="vest-bag__title">马甲包配置</h1>
    </el-row>
    <el-row class="vest-bag__search">
      <span>渠道</span>
      <el-select
        v-model="search.channelId"
        filterable
        ref="select"
        @focus="closeReadOnly"
        @hook:mounted="closeReadOnly"
        @visible-change="closeReadOnly"
        placeholder="请选择"
      >
        <el-option
          v-for="(item, itemIndex) in channelsList"
          :key="item.channelId"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span>代理Ip</span>
      <el-input style="width: 150px;" v-model="search.proxyIp" clearable placeholder="代理Ip"></el-input>
      <el-button type="info" @click="getCurChannel"> 查询 </el-button>
      <el-button type="primary" @click="createDialogShow"> 新建渠道 </el-button>

      <div style="width: 300px"></div>

      <el-button type="primary" @click="allExpand"> 全部展开 </el-button>
      <el-button type="primary" @click="expandList = []"> 全部收起 </el-button>
      <el-button type="primary" @click="importAll"> 导入 </el-button>
      <el-button type="primary" @click="exportAll"> 导出 </el-button>
    </el-row>
    <el-collapse v-if="channelCopyData" v-model="expandList">
      <el-collapse-item title="渠道属性" name="1">
        <el-form :model="channelCopyData.propData" ref="propForm">
          <el-descriptions title="" :column="3" border>
            <el-descriptions-item>
              <template slot="label"> 渠道: </template>
              {{ channelCopyData.propData.channel }}
              <el-button
                size="small"
                type="danger"
                style="margin-left: 20px"
                @click="deleteAppSure"
                >删除</el-button
              >
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 配置类型: </template>
              <el-select
                v-model="channelCopyData.propData.configType"
                placeholder="请选择"
                :disabled="!isEdit.propData"
              >
                <el-option
                  v-for="item in channelOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 谷歌登录: </template>
              <el-switch
                v-model="channelCopyData.propData.googleLogin"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 谷歌支付: </template>
              <el-switch
                v-model="channelCopyData.propData.googleRecharge"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 苹果登录: </template>
              <el-switch
                v-model="channelCopyData.propData.appleLogin"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 苹果支付: </template>
              <el-switch
                v-model="channelCopyData.propData.appleRecharge"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> facebook登录和事件回传: </template>
              <el-switch
                v-model="channelCopyData.propData.facebookLogin"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 包含订阅 </template>
              <el-switch
                v-model="channelCopyData.propData.subscription"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 是否使用JSON </template>
              <el-switch
                v-model="channelCopyData.propData.useJson"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label"> 是否复核 </template>
              <el-switch
                v-model="channelCopyData.propData.review"
                active-text="已复核"
                inactive-text="未复核"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item class="detect-porn-item">
              <template slot="label"> 是否鉴黄 </template>
              <el-switch
                v-model="channelCopyData.propData.detectPorn"
                active-text="鉴黄"
                inactive-text="不鉴黄"
                :active-value="2"
                :inactive-value="1"
                :disabled="!isEdit.propData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 创建人: </template>
              {{ creatorName || '--' }}
            </el-descriptions-item>
          </el-descriptions>
        </el-form>
        <div class="button-group">
          <el-button
            @click="edit('propData')"
            size="small"
            type="primary"
            v-if="!isEdit.propData"
            >编辑</el-button
          >
          <template v-else>
            <el-button @click="cancel('propData')" size="small">取消</el-button>
            <el-button
              @click="submitUpdate('propForm', 'propData')"
              size="small"
              type="primary"
              >提交</el-button
            >
          </template>
        </div>
      </el-collapse-item>
      <el-collapse-item title="基础" name="2">
        <el-form :model="channelCopyData.baseData" ref="baseForm" :rules="baseFormRules">
          <el-descriptions
            title=""
            :column="2"
            border
            v-if="channelDetailData.propData"
          >
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 应用名称:
              </template>

              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.appName }}
              </span>
              <el-form-item required inline prop="appName" v-else>
                <el-input v-model="channelCopyData.baseData.appName"></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> cdn域名:
              </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.cdn }}
              </span>
              <el-form-item required inline prop="cdn" v-else>
                <el-input v-model="channelCopyData.baseData.cdn"></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 视频cdn域名:
              </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.videoCdn }}
              </span>
              <el-form-item required inline prop="videoCdn" v-else>
                <el-input
                  v-model="channelCopyData.baseData.videoCdn"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> logo:
              </template>
              <img
                :src="channelCopyData.baseData.logo"
                style="width: 50px; height: 50px"
                alt=""
                v-if="!isEdit.baseData"
              />
              <el-form-item required inline prop="logo" v-else>
                <el-input v-model="channelCopyData.baseData.logo">
                  <el-button slot="append" icon="el-icon-upload" type="file">
                    <input
                      type="file"
                      @change="uploadLogo"
                      class="file-input"
                    />
                  </el-button>
                </el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 默认头像: </template>
              <img
                :src="channelCopyData.baseData.defHead"
                style="width: 50px; height: 50px"
                alt=""
                v-if="!isEdit.baseData"
              />
              <el-form-item inline prop="defHead" v-else>
                <el-input v-model="channelCopyData.baseData.defHead"></el-input>
              </el-form-item>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label"> facebook来源key: </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.fbAdSourceKey }}
              </span>
              <el-form-item inline prop="fbAdSourceKey" v-else>
                <el-input
                  v-model="channelCopyData.baseData.fbAdSourceKey"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 同源渠道配置: </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.originalChannel }}
              </span>
              <el-form-item inline prop="originalChannel" v-else>
                <el-input
                  v-model="channelCopyData.baseData.originalChannel"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> api域名:
              </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.domainName }}
              </span>
              <el-form-item required inline prop="domainName" v-else>
                <el-input
                  v-model="channelCopyData.baseData.domainName"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> A面开关 </template>
              <el-switch
                v-model="channelCopyData.baseData.abSide"
                active-text="开启"
                inactive-text="不开启"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.baseData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item
              v-if="channelCopyData.baseData.abSide === 1"
            >
              <template slot="label"> 默认AB面 </template>
              <el-switch
                v-model="channelCopyData.baseData.defaultAbSide"
                active-text="B"
                inactive-text="A"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.baseData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 缩略图开关 </template>
              <el-switch
                v-model="channelCopyData.baseData.useThumbnail"
                active-text="开"
                inactive-text="关"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.baseData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item
              v-if="channelCopyData.baseData.useThumbnail === 1"
            >
              <template slot="label"> 缩略图配置 </template>
              <el-input
                v-model="channelCopyData.baseData.cropSuffix"
                :disabled="!isEdit.baseData"
              ></el-input>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 客户端类型: </template>
              <el-select
                v-model="channelCopyData.baseData.hostClient"
                placeholder="请选择"
                :disabled="!isEdit.baseData"
              >
                <el-option
                  v-for="item in hostOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 是否下架 </template>
              <!-- <el-switch
                class="switch-red"
                @change="changeRemoved"
                v-model="channelCopyData.baseData.removed"
                active-text="已下架"
                inactive-text="未下架"
                :active-value="1"
                :inactive-value="0"
                active-color="#ff4949"
                :disabled="!isEdit.baseData"
              ></el-switch> -->
              <el-select
                v-model="channelCopyData.baseData.removed"
                placeholder="请选择"
                :disabled="!isEdit.baseData"
              >
                <el-option
                  v-for="item in removeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> 商店链接:
              </template>
              <span v-if="!isEdit.baseData">
                {{ channelCopyData.baseData.appstoreUrl }}
              </span>
              <el-form-item required inline prop="appstoreUrl" v-else>
                <el-input
                  v-model="channelCopyData.baseData.appstoreUrl"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 是否直接包 </template>
              <el-switch
                v-model="channelCopyData.baseData.direct"
                active-text="是"
                inactive-text="不是"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.baseData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> 是否内部使用列表 </template>
              <el-switch
                v-model="channelCopyData.baseData.contentShowMode"
                active-text="是"
                inactive-text="不是"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.baseData && channelCopyData.baseData.canChangeContentShowMode"
              ></el-switch>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('baseData')"
              size="small"
              type="primary"
              v-if="!isEdit.baseData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('baseData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('baseForm', 'baseData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="音视频配置(谷歌)" name="3">
        <el-form :model="channelCopyData.streamData" ref="streamForm">
          <el-descriptions
            title=""
            :column="2"
            border
            v-if="channelCopyData.streamData"
          >
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 频道类型:
              </template>
              <el-select
                v-model="channelCopyData.streamData.streamChannel"
                placeholder="请选择"
                :disabled="!isEdit.streamData"
              >
                <el-option
                  v-for="item in channelType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> appId:
              </template>
              <span v-if="!isEdit.streamData">
                {{ channelCopyData.streamData.appId }}
              </span>
              <el-form-item required inline prop="appId" v-else>
                <el-input v-model="channelCopyData.streamData.appId"></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> appSecretKey:
              </template>
              <span v-if="!isEdit.streamData">
                {{ channelCopyData.streamData.appSecretKey }}
              </span>
              <el-form-item required inline prop="appSecretKey" v-else>
                <el-input
                  v-model="channelCopyData.streamData.appSecretKey"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('streamData')"
              size="small"
              type="primary"
              v-if="!isEdit.streamData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('streamData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('streamForm', 'streamData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="代理配置" name="4">
        <el-form :model="channelCopyData.proxyData" ref="proxyForm">
          <el-descriptions
            title=""
            :column="3"
            border
            v-if="channelCopyData.propData"
          >
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 代理配置:
              </template>
              <span v-if="!isEdit.proxyData">
                {{ channelCopyData.proxyData.ip }}
              </span>
              <el-form-item required inline prop="ip" v-else>
                <el-input v-model="channelCopyData.proxyData.ip"></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 同代理IP渠道:
              </template>
              <span v-if="!isEdit.proxyData">
                {{ channelCopyData.proxyData.sameIpChannel }}
              </span>
              <el-form-item required inline prop="ip" v-else>
                <el-input v-model="channelCopyData.proxyData.sameIpChannel" :disabled="true"></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('proxyData')"
              size="small"
              type="primary"
              v-if="!isEdit.proxyData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('proxyData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('proxyForm', 'proxyData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="客服信息" name="5">
        <el-form :model="channelCopyData.customerServiceBO" ref="ServiceBOForm">
          <el-descriptions
            title=""
            :column="2"
            border
            v-if="channelCopyData.propData"
          >
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>名称:
              </template>
              <span v-if="!isEdit.customerServiceBO">
                {{ channelCopyData.customerServiceBO.name }}
              </span>
              <el-form-item required inline prop="name" v-else>
                <el-input
                  v-model="channelCopyData.customerServiceBO.name"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"
                ><i class="require-icon">*</i> 头像:
              </template>
              <img
                :src="channelCopyData.customerServiceBO.head"
                style="width: 50px; height: 50px"
                alt=""
                v-if="!isEdit.customerServiceBO"
              />
              <el-form-item required inline prop="head" v-else>
                <el-input
                  v-model="channelCopyData.customerServiceBO.head"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">banner: </template>
              <span v-if="!isEdit.customerServiceBO">
                {{ channelCopyData.customerServiceBO.banner }}
              </span>
              <el-form-item inline prop="banner" v-else>
                <el-input
                  v-model="channelCopyData.customerServiceBO.banner"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('customerServiceBO')"
              size="small"
              type="primary"
              v-if="!isEdit.customerServiceBO"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('customerServiceBO')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('ServiceBOForm', 'customerServiceBO')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item
        title="谷歌支付"
        name="6"
        v-if="channelCopyData && channelCopyData.propData.googleRecharge"
      >
        <el-form
          :model="channelCopyData.googleRechargeData"
          ref="googleRechargeForm"
        >
          <el-descriptions
            title=""
            :column="2"
            border
            v-if="channelCopyData.googleRechargeData"
          >
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> CLIENT_ID:
              </template>
              <span v-if="!isEdit.googleRechargeData">
                {{ channelCopyData.googleRechargeData.clientId }}
              </span>
              <el-form-item required inline prop="clientId" v-else>
                <el-input
                  v-model="channelCopyData.googleRechargeData.clientId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> CLIENT_SECRET:
              </template>
              <span v-if="!isEdit.googleRechargeData">
                {{ channelCopyData.googleRechargeData.clientSecret }}
              </span>
              <el-form-item required inline prop="clientSecret" v-else>
                <el-input
                  v-model="channelCopyData.googleRechargeData.clientSecret"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> REFRESH_TOKEN:
              </template>
              <span v-if="!isEdit.googleRechargeData">
                {{ channelCopyData.googleRechargeData.refreshToken }}
              </span>
              <el-form-item required inline prop="refreshToken" v-else>
                <el-input
                  v-model="channelCopyData.googleRechargeData.refreshToken"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> token_key:
              </template>
              <span v-if="!isEdit.googleRechargeData">
                {{ channelCopyData.googleRechargeData.tokenKey }}
              </span>
              <el-form-item required inline prop="tokenKey" v-else>
                <el-input
                  v-model="channelCopyData.googleRechargeData.tokenKey"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>packageName:
              </template>
              <span v-if="!isEdit.googleRechargeData">
                {{ channelCopyData.googleRechargeData.packageName }}
              </span>
              <el-form-item required inline prop="packageName" v-else>
                <el-input
                  v-model="channelCopyData.googleRechargeData.packageName"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('googleRechargeData')"
              size="small"
              type="primary"
              v-if="!isEdit.googleRechargeData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('googleRechargeData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="
                  submitUpdate('googleRechargeForm', 'googleRechargeData')
                "
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item
        title="苹果登录"
        name="7"
        v-if="channelCopyData && channelCopyData.propData.appleLogin"
      >
        <el-form :model="channelCopyData.appleLoginData" ref="appleLoginForm">
          <el-descriptions
            title=""
            :column="2"
            border
            v-if="channelCopyData.appleLoginData"
          >
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> CLIENT_ID:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.clientId }}
              </span>
              <el-form-item required inline prop="clientId" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.clientId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> CLIENT_SECRET: </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.clientSecret }}
              </span>
              <el-form-item inline prop="clientSecret" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.clientSecret"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label"> expireTime: (秒时间戳)</template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.expireTime }}
              </span>
              <el-form-item inline prop="expireTime" v-else>
                <el-input v-model="channelCopyData.appleLoginData.expireTime">
                  <el-button slot="append" @click="generatorTimestamp"
                    >生成时间戳</el-button
                  >
                </el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>keyId:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.keyId }}
              </span>
              <el-form-item required inline prop="keyId" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.keyId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>teamId:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.teamId }}
              </span>
              <el-form-item required inline prop="teamId" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.teamId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>生成密钥的p8文件内容:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.keyStr }}
              </span>
              <el-form-item required inline prop="keyStr" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.keyStr"
                  type="textarea"
                  :rows="4"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label"> web登录开关: </template>
              <el-switch
                v-model="channelCopyData.appleLoginData.webAppleLogin"
                active-text="开"
                inactive-text="关"
                :active-value="1"
                :inactive-value="0"
                :disabled="!isEdit.appleLoginData"
              ></el-switch>
            </el-descriptions-item>
            <el-descriptions-item
              v-if="channelCopyData.appleLoginData.webAppleLogin === 1"
            >
              <template slot="label">
                <i class="require-icon">*</i> WEB_CLIENT_ID:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.webClientId }}
              </span>
              <el-form-item required inline prop="webClientId" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.webClientId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item
              v-if="channelCopyData.appleLoginData.webAppleLogin === 1"
            >
              <template slot="label">
                <i class="require-icon">*</i> WEB_CLIENT_SECRET:
              </template>
              <span v-if="!isEdit.appleLoginData">
                {{ channelCopyData.appleLoginData.webClientSecret }}
              </span>
              <el-form-item required inline prop="webClientSecret" v-else>
                <el-input
                  v-model="channelCopyData.appleLoginData.webClientSecret"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('appleLoginData')"
              size="small"
              type="primary"
              v-if="!isEdit.appleLoginData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('appleLoginData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('appleLoginForm', 'appleLoginData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item
        title="苹果支付"
        name="8"
        v-if="channelCopyData && channelCopyData.propData.appleRecharge"
      >
        <el-form
          :model="channelCopyData.appleRechargeData"
          ref="appleRechargeForm"
        >
          <el-descriptions
            title=""
            :column="3"
            border
            v-if="channelCopyData.appleRechargeData"
          >
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>包名:
              </template>
              <span v-if="!isEdit.appleRechargeData">
                {{ channelCopyData.appleRechargeData.packageName }}
              </span>
              <el-form-item required inline prop="packageName" v-else>
                <el-input
                  v-model="channelCopyData.appleRechargeData.packageName"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>内购密钥:
              </template>
              <span v-if="!isEdit.appleRechargeData">
                {{ channelCopyData.appleRechargeData.appstoreOmom }}
              </span>
              <el-form-item required inline prop="appstoreOmom" v-else>
                <el-input
                  v-model="channelCopyData.appleRechargeData.appstoreOmom"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('appleRechargeData')"
              size="small"
              type="primary"
              v-if="!isEdit.appleRechargeData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('appleRechargeData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('appleRechargeForm', 'appleRechargeData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item
        title="facebook登录"
        name="9"
        v-if="channelCopyData && channelCopyData.propData.facebookLogin"
      >
        <el-form
          :model="channelCopyData.facebookLoginData"
          ref="facebookLoginForm"
        >
          <el-descriptions
            title=""
            :column="3"
            border
            v-if="channelCopyData.facebookLoginData"
          >
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i>id:
              </template>
              <span v-if="!isEdit.facebookLoginData">
                {{ channelCopyData.facebookLoginData.facebookId }}
              </span>
              <el-form-item required inline prop="facebookId" v-else>
                <el-input
                  v-model="channelCopyData.facebookLoginData.facebookId"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item>
              <template slot="label">
                <i class="require-icon">*</i> secret:
              </template>
              <span v-if="!isEdit.facebookLoginData">
                {{ channelCopyData.facebookLoginData.facebookKey }}
              </span>
              <el-form-item required inline prop="facebookKey" v-else>
                <el-input
                  v-model="channelCopyData.facebookLoginData.facebookKey"
                ></el-input>
              </el-form-item>
            </el-descriptions-item>
          </el-descriptions>
          <div class="button-group">
            <el-button
              @click="edit('facebookLoginData')"
              size="small"
              type="primary"
              v-if="!isEdit.facebookLoginData"
              >编辑</el-button
            >
            <template v-else>
              <el-button @click="cancel('facebookLoginData')" size="small"
                >取消</el-button
              >
              <el-button
                @click="submitUpdate('facebookLoginForm', 'facebookLoginData')"
                size="small"
                type="primary"
                >提交</el-button
              >
            </template>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="广告设置" name="10">
        <el-table
          :data="channelCopyData.advertisementList"
          style="width: 100%"
          border
        >
          <el-table-column prop="key" label="key" align="center">
          </el-table-column>
          <el-table-column
            prop="fieldName"
            label="field_name"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="advId"
            label="adv_id"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" @click="advDialogShow()" size="small"
                >创建</el-button
              >
            </template>
            <template slot-scope="scope">
              <el-button @click="advDialogShow(scope.row)" size="small"
                >编辑</el-button
              >
              <el-button
                type="danger"
                @click="deleteAdv(scope.row)"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>

    <el-dialog
      title="创建渠道"
      :visible.sync="createData.isVisible"
      width="30%"
    >
      <el-form :model="createData.data">
        <el-form-item label="渠道" inline>
          <el-input
            v-model.trim="createData.data.channel"
            style="display: inline-block; width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label=" 配置类型:">
          <el-select v-model="createData.data.configType" placeholder="请选择">
            <el-option
              v-for="item in channelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="谷歌登录:">
          <el-switch
            v-model="createData.data.googleLogin"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="谷歌支付:">
          <el-switch
            v-model="createData.data.googleRecharge"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="苹果登录:">
          <el-switch
            v-model="createData.data.appleLogin"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="苹果支付:">
          <el-switch
            v-model="createData.data.appleRecharge"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="facebook登录:">
          <el-switch
            v-model="createData.data.facebookLogin"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="包含订阅:">
          <el-switch
            v-model="createData.data.subscription"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否使用JSON:">
          <el-switch
            v-model="createData.data.useJson"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item label="是否鉴黄:">
          <el-switch
            v-model="createData.data.detectPorn"
            active-text="鉴黄"
            inactive-text="不鉴黄"
            :active-value="2"
            :inactive-value="1"
          ></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createData.isVisible = false">取 消</el-button>
        <el-button type="primary" @click="createChannel">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="广告" :visible.sync="createAdvData.isVisible" width="30%">
      <el-form :model="createAdvData.data" ref="advForm" label-width="100px">
        <el-form-item label="key" prop="key" required>
          <el-input v-model="createAdvData.data.key"></el-input>
        </el-form-item>
        <el-form-item label="fieldName" prop="fieldName" required>
          <el-input v-model="createAdvData.data.fieldName"></el-input>
        </el-form-item>
        <el-form-item label="advId" prop="advId" required>
          <el-input v-model="createAdvData.data.advId"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createAdvData.isVisible = false">取 消</el-button>
        <el-button type="primary" @click="createAdv">确 定</el-button>
      </span>
    </el-dialog>

    <JsonEdit
      :json="jsonData.data"
      v-model="jsonData.visible"
      :is-import="jsonData.isImport"
    />
  </el-card>
</template>
<script>
import {
  getAppList,
  updateAppProps,
  updateAppBase,
  updateAppStream,
  updateAppAdmin,
  updateGoogleRecharge,
  updateAppleLogin,
  updateAppleRecharge,
  updateFacebookLogin,
  updateProxy,
  updateCustomer,
  deleteAdvertisement,
  updateAdvertisement,
  deleteApp,
} from '@/api/appRequest'
import JsonEdit from '../../components/JSONEdit/JsonEdit.vue'
import { remove } from 'nprogress'
export default {
  components: {
    JsonEdit,
  },
  data() {
    return {
      expandList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
      jsonData: {
        visible: false,
        isImport: false,
        data: {},
      },
      channelOptions: [
        { value: 0, label: '无特定渠道' },
        { value: 1, label: '谷歌应用商店' },
        { value: 2, label: '苹果应用商店' },
        { value: 3, label: 'PC网页端' },
        { value: 4, label: 'Flutter Google Play' },
        { value: 5, label: 'Flutter iOS' },
        { value: 6, label: 'Web Google Play' },
        { value: 7, label: 'Web iOS' },
        // { value: 8, label: '纯Web应用' },
      ],
      hostOptions: [
        { value: 0, label: '用户端' },
        { value: 1, label: 'ios主播端' },
        { value: 2, label: '安卓主播端' },
      ],
      channelType: [
        { value: 0, label: '即构' },
        { value: 1, label: '声网' },
        { value: 2, label: 'TRTC' },
      ],
      removeOptions: [
        { value: 0, label: '未下架' },
        { value: 1, label: '已下架' },
        { value: 2, label: '待审核' },
        { value: 3, label: '下架未停服' },
      ],
      search: {
        channelId: '',
        proxyIp: '',
      },
      currentChannel: {
        channel: '',
        channelId: '',
      },
      channelsList: [],
      // 详细数据
      channelDetailData: null,
      // 复制的数据
      channelCopyData: null,
      channelShow: false,
      createData: {
        isVisible: false,
        data: {
          channel: '',
          configType: 1,
          googleLogin: 0,
          googleRecharge: 0,
          appleLogin: 0,
          appleRecharge: 0,
          subscription: 0,
          useJson: 0,
          facebookLogin: 0,
          detectPorn: 1,
        },
        channelVal: 1,
      },
      createAdvData: {
        isVisible: false,
        data: {},
      },
      isEdit: {
        propData: false,
        baseData: false,
        streamData: false,
        proxyData: false,
        customerServiceBO: false,
        googleRechargeData: false,
        appleLoginData: false,
        appleRechargeData: false,
        facebookLoginData: false,
      },
      baseFormRules: {
        appName: [
          { required: true, message: '应用名称不能为空', trigger: 'blur' }
        ],
        cdn: [
          { required: true, message: 'cdn域名不能为空', trigger: 'blur' }
        ],
        videoCdn: [
          { required: true, message: '视频cdn域名不能为空', trigger: 'blur' }
        ],
        logo: [
          { required: true, message: 'logo不能为空', trigger: 'blur' }
        ],
        domainName: [
          { required: true, message: 'api域名不能为空', trigger: 'blur' }
        ],
        appstoreUrl: [
          { required: true, message: '商店链接不能为空', trigger: 'blur' }
        ]
      },
    }
  },
  computed: {
    creatorName() {
      if (!this.currentChannel.channel || !this.channelsList.length) {
        return ''
      }
      const channel = this.channelsList.find((item) => {
        return item.name === this.currentChannel.channel || item.value === this.currentChannel.channel
      })
      return channel ? channel.creator || '' : ''
    },
  },
  watch: {
    'jsonData.visible': function (val) {
      if (this.jsonData.isImport && !val) {
        this.getChannelList()
      }
    },
    'createData.isVisible': function (val) {
      if (!val) {
        this.createData.channelVal = 1
      }
    },
    'createData.data.configType': {
      immediate: true,
      handler(val) {
        if (val === 1) {
          this.createData.data.googleLogin = 1
          this.createData.data.googleRecharge = 1
        } else if (val === 2) {
          this.createData.data.appleLogin = 1
        }
      },
    },
    'channelCopyData.baseData.useThumbnail': {
      handler(val) {
        if (
          val === 0 &&
          this.channelCopyData.baseData &&
          this.channelCopyData.baseData.cropSuffix
        ) {
          this.channelCopyData.baseData.cropSuffix = null
        }
      },
    },
  },
  mounted() {
    // 获取所有的渠道
    this.getChannelList()
  },
  methods: {
    closeReadOnly(val) {
      this.$nextTick(() => {
        if (!val) {
          const input = this.$refs.select.$el.querySelector('.el-input__inner')
          const timer = setTimeout(() => {
            input.removeAttribute('readonly')
            clearTimeout(timer)
          }, 200)
        }
      })
    },
    async uploadLogo(e) {
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('cover', 0)
      formData.append('dir', 'default/head/')
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formData
      )
      if (res.code !== 0) this.$message.error('upload fail')
      this.$set(this.channelCopyData.baseData, 'logo', res.data)
    },
    generatorTimestamp() {
      this.$prompt('请输入距离现在的天数', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\d+$/,
        inputErrorMessage: '必须为数字',
        inputValue: 170,
      })
        .then(({ value }) => {
          const curTime = Math.floor(Number(new Date() / 1000))
          this.$set(
            this.channelCopyData.appleLoginData,
            'expireTime',
            curTime + 24 * 60 * 60 * value
          )
          this.$message.success('success')
        })
        .catch(() => {})
    },
    // 全部展开
    allExpand() {
      this.expandList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10']
    },
    // 导出数据为JSON
    exportAll() {
      if (this.channelDetailData) {
        this.jsonData.visible = true
        this.jsonData.isImport = false
        this.jsonData.data = JSON.parse(JSON.stringify(this.channelDetailData))
      } else {
        this.$message.error('先查询渠道')
      }
    },
    importAll() {
      this.jsonData.visible = true
      this.jsonData.isImport = true
      this.jsonData.data = {}
    },
    // 创建渠道弹窗显示
    createDialogShow() {
      this.createData.isVisible = true
      this.createData.data = {
        channel: '',
        configType: 1,
        googleLogin: 0,
        googleRecharge: 0,
        appleLogin: 0,
        appleRecharge: 0,
        subscription: 0,
        useJson: 0,
        facebookLogin: 0,
        detectPorn: 1,
      }
    },
    // 创建渠道
    async createChannel() {
      console.log(this.createData.data)
      if (this.createData.data.channel === '') {
        return this.$message.error('渠道不能为空')
      }
      const res = await updateAppProps({ 
        data: {
          ...this.createData.data,
          channel: this.createData.data.channel.toLowerCase()
        }
      })
      if (res.code === 0) {
        this.createData.isVisible = false
        this.getChannelList()
        return this.$message.success('成功')
      } else {
        return this.$message.error(res.msg)
      }
    },
    // 获取渠道列表
    async getChannelList() {
      const { data: res } = await this.$axios(
        this.$store.getters.path.newChannelList +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
      )
      if (res.code == 0) {
        this.channelsList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    // 获取当前渠道数据
    async getCurChannel() {
      const res = await getAppList({ channel: this.search.channelId, proxyIp: this.search.proxyIp })
      if(res.code !== 0) return this.$message.error(res.msg)
      this.channelDetailData = res.data
      this.channelCopyData = JSON.parse(JSON.stringify(this.channelDetailData))
      this.currentChannel.channel = this.search.channelId
      this.currentChannel.channelId = this.channelsList.find((item) => {
        return item.name === this.currentChannel.channel
      }).channelId
    },
    // 设置渠道id
    setChannelId(val) {
      this.currentChannel.channel = val
      this.channelShow = false
    },
    // 提交修改
    submitUpdate(ref, val) {
      this.$confirm('是否确认修改?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs[ref].validate(async (valid) => {
          let res = null
          this.filterObject(this.channelCopyData[val])
          console.log(this.channelCopyData[val])
          if (valid) {
            switch (val) {
              case 'propData':
                res = await updateAppProps({
                  data: { ...this.channelCopyData[val] },
                })
                break
              case 'baseData':
                res = await updateAppBase({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'streamData':
                res = await updateAppStream({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'proxyData':
                res = await updateProxy({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'customerServiceBO':
                res = await updateCustomer({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'googleRechargeData':
                res = await updateGoogleRecharge({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'appleLoginData':
                res = await updateAppleLogin({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'appleRechargeData':
                res = await updateAppleRecharge({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              case 'facebookLoginData':
                res = await updateFacebookLogin({
                  data: { ...this.channelCopyData[val] },
                  channel: this.currentChannel.channel,
                })
                break
              default:
                break
            }
            if (res.code === 0) {
              this.$message.success('修改成功')
            } else {
              this.$message.error(res.msg)
            }
            this.isEdit[val] = false
            this.getCurChannel()
          } else {
            return false
          }
        })
      })
    },
    // 过滤对象·
    filterObject(obj) {
      if (typeof obj !== 'object') return
      for (const key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
          if (typeof obj[key] === 'string') {
            obj[key] = obj[key].trim()
          }
        }
      }
    },
    // 取消某个表单的保存
    cancel(val) {
      this.isEdit[val] = false
      this.channelCopyData[val] = JSON.parse(
        JSON.stringify(this.channelDetailData[val])
      )
    },
    // 点击编辑进入可编辑状态
    edit(val) {
      this.isEdit[val] = true
    },
    // 删除
    deleteAdv(row) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await deleteAdvertisement({ id: row.id })
        if (res.code === 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.msg)
        }
        this.getCurChannel()
      })
    },
    deleteAppSure() {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const res = await deleteApp({ channel: this.currentChannel.channel })
        if (res.code === 0) {
          this.$message.success('删除成功')
        } else {
          this.$message.error(res.msg)
        }
        this.getCurChannel()
      })
    },
    advDialogShow(row) {
      if (row) {
        this.createAdvData.data = JSON.parse(JSON.stringify(row))
      } else {
        this.createAdvData.data = {
          key: '',
          fieldName: '',
          advId: '',
        }
      }
      this.createAdvData.isVisible = true
    },
    async createAdv() {
      this.$refs.advForm.validate(async (valid) => {
        if (valid) {
          const res = await updateAdvertisement({
            channel: this.currentChannel.channel,
            data: this.createAdvData.data,
          })
          if (res.code === 0) {
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.msg)
          }
          this.createAdvData.isVisible = false
          this.getCurChannel()
        } else {
          return false
        }
      })
    },
    // 修改上下架提示
    changeRemoved(newVal) {
      this.$set(this.channelCopyData.baseData, 'removed', Math.abs(newVal - 1))
      this.$confirm('是否继续该操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$set(this.channelCopyData.baseData, 'removed', Math.abs(newVal))
        })
        .catch(() => {})
    },
  },
}
</script>
<style scoped lang="scss">
.vest-bag {
  min-height: 90vh;

  &__title {
    font-size: 28px;
    font-weight: bold;
    margin: 10px 0;
  }

  &__search {
    display: flex;
    align-items: center;

    .channel {
      position: relative;

      .channelList {
        position: absolute;
        width: 100%;
        padding: 10px;
        font-size: 12px;
        line-height: 30px;
        z-index: 3;

        li {
          border-bottom: 1px solid #ddd;
        }

        height: 200px;
        overflow: auto;
        top: 100%;
        left: 0;
        background: #f9f9f9;
      }

      span {
        display: block;
        position: absolute;
        top: 0;
        font-size: 20px;
        color: #aaa;
        right: 5px;
        line-height: 40px;
      }
    }

    .el-input {
      width: 200px;
    }

    > * + * {
      margin-left: 10px;
    }
  }
}

.file-input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
}

.button-group {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.require-icon {
  color: red;
}

.detect-porn-item {
  ::v-deep .el-descriptions-item__label {
    color: red;
  }
}
</style>

<style lang="scss">
.el-descriptions-item__label {
  vertical-align: middle;
}

.el-descriptions-item__content > span {
  display: flex;
  min-width: 200px;
  height: inherit;
}

.switch-red {
  .is-active {
    color: #ff4949 !important;
  }
}
</style>
